// 錄影覆寫模式標籤（plan/vms-web-v0.md DEV-10）：kinio_storage.overwrite 照 protocol clusters.yaml 值域。
import { useTranslation } from 'react-i18next';
import type { OverwriteMode } from '../../lib/deviceApi';

/** kinio_storage.overwrite（-1 自動覆寫 / 0 不覆寫 / N 保留 N 天）；不覆寫標警示色——滿了設備會停錄。 */
export function OverwriteLabel({ m }: { m: OverwriteMode }) {
  const { t } = useTranslation();
  const text = m.kind === 'days' ? t('health.overwrite_days', { count: m.days }) : t(`health.overwrite_${m.kind}`);
  return (
    <span data-overwrite={m.kind} className={m.kind === 'off' ? 'warn-text' : undefined} title={t('health.overwrite')}>
      {m.kind === 'off' && <span className="dot health-warn" />}
      {text}
    </span>
  );
}
